<template>
<div class="chapter">
<div class="inner_page">
<h1 class="title"><a id="page_iii"></a>Poetic Diction</h1>
<p class="tit-int1">A Study in Meaning</p>
<p class="author">Owen Barfield</p>
<div class="img_containert"><img alt="image" src="images/logo.jpg"/></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?a098b692